class LS {
  static get isAvailable() {
    const test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (error) {
      return false;
    }
  }
  static has(key) {
    if (!this.isAvailable) return false;
    return !!this.get(key);
  }
  static set(key, data) {
    if (!this.isAvailable) return;
    const value = JSON.stringify(data);
    localStorage.setItem(key, value);
  }
  static get(key) {
    if (!this.isAvailable) return null;
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  }
  static remove(key) {
    if (!this.isAvailable) return;
    localStorage.removeItem(key);
  }
}

export { LS as default };
